export default __webpack_public_path__ + "static/media/web-devices.2c3b549b.svg";